module.exports = __webpack_public_path__ + "img/sycamore.44e2a0d0.png";